<template>
  <div class="container p-30 fs-16">
    <div class="logo mb-20 py-20">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 397 106">
        <path fill="#484e6c" d="M162.23 1.68h3.05V0h-7.43v.15c-.46 1.53-2.44 6.41-4.88 12.51-1.38 3.2-2.9 6.86-4.27 10.52-.77-1.83-1.38-3.81-2.14-5.64-2.89-7.78-5.64-15.25-6.25-17.39V0h-8.54v1.68h2.59c.61 0 .92.3.92 1.06 0 2.14-2 21.35-2.59 25.47h-3.66v1.68h10.67v-1.68h-3.55l1.7-20.89 7.78 20.28a2.76 2.76 0 0 0 2.42 1.82 2.24 2.24 0 0 0 2.44-2 2.9 2.9 0 0 0-.31-1.07l7.93-19.21 1.68 20.89h-3.36v1.68h11.75v-1.5h-3.33c-.64-3.79-2.47-23.18-2.62-26.53Zm25.47 24.24a2.07 2.07 0 0 1-2 .92c-1.06 0-1.52-.61-1.52-2 0-.92.15-2 .15-3a32.78 32.78 0 0 0 .31-3.82c0-4.11-1.83-6.25-5.65-6.25-4.11 0-6.71 3.36-6.71 5.64a1.64 1.64 0 0 0 1.68 1.83 1.92 1.92 0 0 0 1.89-1.55 3.23 3.23 0 0 1 3-2.75c1.22 0 2.29.31 2.29 4v.91c-4 2-8.24 4.12-8.24 7.78 0 1.83 1.22 2.9 3.36 2.9 2.29 0 4.27-2 5.18-3.81.31 2.28 1.38 3.5 3 3.5 2.6 0 3.82-2.89 4.12-3.81l.15-.15-.86-.64Zm-6.56-4.42c-.31 4.42-2.14 6-3.51 6a1 1 0 0 1-1.07-1.08c-.15-1.56 1.68-3.39 4.58-4.92ZM197 5.34a2.18 2.18 0 0 0 2.13-2.14A2.32 2.32 0 0 0 197 .91a2.22 2.22 0 0 0-2.15 2.29A2.09 2.09 0 0 0 197 5.34Zm1.98 6.25v-.31l-.91-.15-.16.15a12.05 12.05 0 0 1-5.64 2.44h-.3v.77l2.59 1.06v12.66h-2.59v1.68h8.88v-1.68h-2.59c.11-5.34.42-12.66.72-16.62Zm13.72 8.23c-1.52-.76-3-1.52-3-3a2 2 0 0 1 2-2.28 1.5 1.5 0 0 1 1.52 1.06 1.84 1.84 0 0 0 1.63 1.17 1.73 1.73 0 0 0 1.68-1.83c0-1.67-1.53-3.5-4.58-3.5a5.68 5.68 0 0 0-5.79 5.79c0 3.66 2.44 4.73 4.42 5.64 1.52.77 2.59 1.22 2.59 2.6s-1.07 2.28-2.74 2.28a3.35 3.35 0 0 1-3.67-3.33v-.31h-1.22v.31a3.62 3.62 0 0 0-.16 1.22c0 2.9 2.14 4.73 5.19 4.73s5.95-1.83 5.95-5.34c.45-3.07-1.83-4.29-3.82-5.21Zm18.61-8.08a9.46 9.46 0 1 0 9.45 9.46 9.5 9.5 0 0 0-9.45-9.46Zm.15 16.78c-3.05 0-5.34-3-5.34-7.17s2.14-7 5-7c3.05 0 5.49 3.05 5.49 7.17-.12 4.1-2.25 7-5.15 7Zm31.26-.31v-5.34c0-3.2 0-5.49-.61-7a5.92 5.92 0 0 0-5.95-3.66 9.74 9.74 0 0 0-4.87 1.52c0-.45.15-.91.15-1.37l.15-1.07-.91-.15-.16.15a12.05 12.05 0 0 1-5.67 2.43h-.3v.77l2.59 1.06v12.66h-2.59v1.68h8.84v-1.68h-2.29c0-3.35 0-8.54.31-12.81a5.43 5.43 0 0 1 2.59-.61c2.44 0 3.81.92 4.42 3.05.46 1.53.76 4.58.76 10.22h-2.59v1.68h8.54v-1.53ZM91.62 51.85h-5.18v-2c4.73 0 9-.61 10.83-2.29l.76.3c-.76 4.88-.76 30.35-.76 46.67 0 2.74.76 4 2.74 4a5.69 5.69 0 0 0 4.12-1.83l.46.46c-.92 3.05-3 5.49-6.41 5.49s-4.88-2.44-5.34-5.8h-.3a15.67 15.67 0 0 1-12.2 5.49c-7.47 0-13.27-5.79-13.27-14.79 0-11.13 9.31-16 15.71-16a17.47 17.47 0 0 1 9 2.59V51.85Zm-.61 30.95c-.61-6.55-4-8.69-8.08-8.69-6.1 0-10.21 4.73-10.21 11.44 0 13.72 13.72 14.49 18.45 9.61a77.34 77.34 0 0 0-.16-12.36Zm20.74 3.36c0 6.71 4.88 10.83 11.59 10.83a12 12 0 0 0 8.85-3.51l.76.46c-1.52 5.49-5.18 9.45-11 9.45-9.3 0-14.49-7.32-14.49-14.49 0-11.74 9.15-18 16.17-18 5.49 0 10.22 3.2 10.22 9.3 0 1.37-.31 2.29-2.29 2.29-6.86 0-13-.46-19.22-.61a12.19 12.19 0 0 0-.59 4.28Zm16.47-7.32c0-2.75-3.05-4.42-6.4-4.42a10.05 10.05 0 0 0-9 5.94c10.52-.45 15.4.46 15.4-1.52Zm25.77-26.99v-2c4.73 0 9-.61 10.83-2.29l.76.3c-.61 4.88-1.06 36.3-1.06 52.31h4.57V102H154.6v-1.83h4.58V51.85Zm35.38 30.95c0-6.4-1.83-7.47-4.57-7.47-2.9 0-5.34 2.29-6.1 5.49a2.72 2.72 0 0 1-2.75 2.29 2.59 2.59 0 0 1-2.44-2.75c0-4 4.43-9.6 11.59-9.6 7.48 0 9.46 4.88 9.46 10.67 0 4.12-.76 8.69-.76 12 0 2.9 1.37 4.12 3.2 4.12a4.52 4.52 0 0 0 4-2l.76.61c-.76 1.83-2.74 6.56-6.86 6.56-3.66 0-5-3.2-5.18-7.32h-.31c-1.22 3.51-4.88 7.78-9.15 7.78-3.81 0-5.49-2-5.49-4.73 0-6.1 7.17-9.91 14.64-13.57Zm-9.6 13.62c0 1.37.91 2.28 2.59 2.28 2.59 0 6.4-2.74 6.86-12-6.25 2.97-9.45 6.63-9.45 9.72Zm74.26-1.87.76-5.19h1.68a135 135 0 0 0-.76 15.1h-1.53v-2.59h-34.46v-1.83h6.13V51.69h-6.1v-1.83h20.1v1.83h-6.1c-.61 8.85-.76 31.11-.76 44.69 0 2.13 1.67 2.28 4.72 2.28 6.56 0 14.03-2.13 16.32-4.11Zm13.27-5.19c0 6.71 3.05 8.69 7.47 8.69 3.81 0 7.78-2.44 7.78-6.1v-18.3h-4.58v-1.83h10.88c-.61 5.19-.76 15.71-.76 22.57 0 2.9.76 4 2.59 4a5.7 5.7 0 0 0 4.12-1.83l.45.46c-.91 3.05-2.89 5.64-6.25 5.64s-5.18-3.05-5.18-6.71h-.61c-2 4.12-6.87 6.71-11.44 6.71-5.34 0-10.22-3.36-10.22-11.74V73.81h-4.12v-1.83h10.22c-.05 2.89-.35 10.82-.35 17.38Zm30.65 12.66-.15-1.22c1.67 0 18.14-22.88 21.65-26.84a75.06 75.06 0 0 0-15.71 1.68l-2.44 4.72h-1.52a66.22 66.22 0 0 0 .76-10.21h1.68v1.83h25.31v1.22c-1.52 0-18.3 23.94-21.65 26.84 6.55-.16 13.72-.31 19.06-3.21l.46-3.35h1.83a57.61 57.61 0 0 0-.77 10.22h-2v-1.83h-26.51Z"/>
        <path fill="#484e6c" d="M388.03 63.07a40.84 40.84 0 0 0-4.25-3 15.39 15.39 0 0 0 4.86-8.77c2.13-15.1-16.63-22-28.52-22.73a73.42 73.42 0 0 0-10.9.16 198.53 198.53 0 0 0-20.12 2.69c-9.81 1.62-19.08 3.16-27.24 2.34a34.38 34.38 0 0 1-5.49-1 23.13 23.13 0 0 1-11.23-6.75c-2.08-2.39-4.22-6.24-2.62-11 2.21-6.56 10.12-8.79 17-8.09a23.28 23.28 0 0 1 3.93.72 21.55 21.55 0 0 1 10.53 6.32l.16.11h.14l.19-.36v.39a.56.56 0 0 0 .61-.41.87.87 0 0 0-.12-.67 23.81 23.81 0 0 0-11.18-6.5 25 25 0 0 0-4.09-.75c-7.44-.75-16 1.71-18.47 8.92-.82 2.43-.53 5 .4 7.86 2.23 6.99 10.28 10.87 18.17 12.97a46.29 46.29 0 0 0 7.43 1.33 95.4 95.4 0 0 0 26.14-1.71l1-.13c11.59-1.68 23.79-3.51 35.38-.76 5.18 1.22 10.67 3.35 14.48 7.16 6.61 6.5 3.87 13.51-1.64 18-4.82-2.76-10.71-5-16.1-5.11a20.18 20.18 0 0 0-10.44 2.31c-2.63 1.52-3.94 5.29.21 8.27 3 2.17 7.43 2.61 9.95 2.41 5.42-.52 12.29-2.55 16.68-6.34 3.64 2.13 6.9 4.63 8.82 7.32 11.17 15.68-2.42 31.32-17.54 34.31-10.31 2.05-20.59.44-31-4.77.16.15-.61 3.25.16 3.55 20.12 10.23 51.45 4.12 53.29-20.29.47-5.84-2.07-12.65-8.58-18Zm-11.29-.31a35.6 35.6 0 0 1-10.27 2.49c-5.41.69-11.93-1-12.07-4.58-.13-3.23 5.64-5.14 12.07-5 4.8.12 10.26 1.9 15.07 4.49a21.8 21.8 0 0 1-4.8 2.6Zm-24.19-9.32zM.05 80.92c1.8 24.41 33.17 30.5 53.3 20.3.76-.31 0-3.4.15-3.55-10.36 5.2-20.65 6.81-31 4.77C7.43 99.42-6.15 83.81 5.01 68.13c1.92-2.69 5.17-5.19 8.81-7.33 4.4 3.79 11.26 5.83 16.68 6.34 2.52.21 6.94-.23 10-2.4 4.16-3 2.85-6.76.21-8.28a20.24 20.24 0 0 0-10.43-2.31c-5.38.12-11.28 2.36-16.1 5.12-5.51-4.47-8.25-11.49-1.64-18 3.81-3.81 9.3-6 14.49-7.17 11.59-2.74 23.79-.91 35.37.76l1 .14a95.42 95.42 0 0 0 26.14 1.7 45.59 45.59 0 0 0 7.37-1.28c7.88-2.14 15.95-6 18.21-12.89.92-2.85 1.21-5.44.39-7.86-2.43-7.21-11-9.68-18.47-8.93a25.22 25.22 0 0 0-4.09.76A23.77 23.77 0 0 0 81.78 13a.87.87 0 0 0-.13.67.57.57 0 0 0 .61.41v-.39l.19.35h.14l.16-.11a21.62 21.62 0 0 1 10.53-6.32 25.46 25.46 0 0 1 3.93-.72c6.86-.69 14.77 1.54 17 8.09 1.59 4.72-.55 8.56-2.62 11a23.23 23.23 0 0 1-11.23 6.74 34.58 34.58 0 0 1-5.49 1c-8.17.83-17.44-.71-27.24-2.34-6.64-1.1-13.43-2.22-20.12-2.65a72.23 72.23 0 0 0-10.91-.15C24.71 29.34 5.95 36.2 8.09 51.3a15.31 15.31 0 0 0 4.86 8.78 38.79 38.79 0 0 0-4.25 3C2.15 68.24-.39 75.1.05 80.92Zm15.11-20.86a35.2 35.2 0 0 1 15.07-4.5c6.42-.15 12.19 1.75 12.07 5-.15 3.6-6.67 5.26-12.07 4.58a36 36 0 0 1-10.28-2.5 22.16 22.16 0 0 1-4.79-2.58Zm28.98-6.75z"/>
      </svg>
    </div>
    <div class="mb-20">Wifi Portal</div>
    <div class="mb-20 connect-buttons">
      <button v-show="!connect_method" @click="handleClickMethod(1)">Hotel Guest</button>
      <div class="connect-method-form" v-if="connect_method === 1">
        <div class="mb-20"><input v-model="form.last_name" type="text" placeholder="Last Name" /></div>
        <div class="mb-20"><input v-model="form.room_number" type="text" placeholder="Room Number" /></div>
        <div class="terms mb-20 fs-14">
          <TermsOfService variant="checkbox" consent_text="I agree to the " consent_action_text="Terms and Conditions" @onChangeCheckboxConsent="handleOnChangeCheckboxConsent" />
        </div>
        <div class="mb-20 fs-14">
          <label class="d-flex align-items-start"><input v-model="subscribe" type="checkbox" /><span class="ml-5">Join the Maison De La Luz newsletter.</span></label>
        </div>
        <div class="mb-20" v-if="subscribe">
          <input v-model="form.email_address" type="text" placeholder="Email Address" />
        </div>
        <div class="mb-30">
          <button :disabled="disabled || !show_continue" @click="handleClickConnect()">Continue</button>
        </div>
        <a href="#" class="d-block text-center" @click.prevent="handleClickMethod()">Oops, take me back</a>
      </div>

      <button v-show="!connect_method" @click="handleClickMethod(2)">Visitor</button>
      <div class="connect-method-form" v-if="connect_method === 2">
        <div class="mb-20">
          <input v-model="form.first_name" type="text" placeholder="First Name" />
        </div>
        <div class="mb-20">
          <input v-model="form.last_name" type="text" placeholder="Last Name" />
        </div>
        <div class="mb-20">
          <input v-model="form.email_address" type="text" placeholder="Email" />
        </div>
        <div class="mb-20 fs-14">
          <label class="d-flex align-items-start"><input v-model="subscribe" type="checkbox" /><span class="ml-5">Join the Maison De La Luz newsletter.</span></label>
        </div>
        <div class="terms mb-20 fs-14">
          <TermsOfService variant="checkbox" consent_text="I agree to the " consent_action_text="Terms and Conditions" @onChangeCheckboxConsent="handleOnChangeCheckboxConsent" />
        </div>
        <div class="mb-30">
          <button :disabled="disabled || !show_continue" @click="handleClickConnect()">Continue</button>
        </div>
        <a href="#" class="d-block text-center" @click.prevent="handleClickMethod()">Oops, take me back</a>
      </div>
    </div>
    <div class="py-30">
      <SupportAndDeviceInfo :phone="portal.template.support_phone" :ip="connection_data.client_ip" :mac="connection_data.client_mac" />
    </div>
  </div>
  </template>
  
  <script>
  import TermsOfService from '@/utilities/TermsOfService'
  import SupportAndDeviceInfo from '@/utilities/SupportAndDeviceInfo'
  import Axios from "axios";

  export default {
    name: 'custom_template_maison_de_la_luz',
    props: [ 'template', 'portal', 'connection_data' ],
    components: { TermsOfService, SupportAndDeviceInfo },
    computed: {
      show_continue:function(){
        if(this.connect_method === 1) return this.consent && this.form.last_name && this.form.room_number;
        if(this.connect_method === 2) return (this.consent && !this.subscribe) || (this.consent && this.subscribe && this.form.first_name && this.form.last_name && this.form.email_address);
      },
    },
    data(){
      return{
        revinate_url: 'https://contact-api.inguest.com/api/add-contacts-to-lists',
        revinate_token: 'c93291b7-95fa-455a-87b0-c1d3bf65abfe',
        disabled: true,
        connect_method: null,
        consent: false,
        subscribe: false,
        form: {
          // access_code: null,
          room_number: null,
          first_name: null,
          last_name: null,
          email_address: null,
        },
      }
    },
    watch: {
      'form': {
        deep: true,
        handler(){ this.disabled = false }
      }
    },
    created(){
      document.documentElement.classList.add('maisonDeLaLuz');
    },
    methods: {
      handleOnChangeCheckboxConsent(value){
        this.consent = value;
      },
      handleClickMethod(method=null){
        this.disabled = false;
        this.connect_method = method;
        this.consent = false;
        this.subscribe = false;
        this.form.room_number = null;
        this.form.first_name = null;
        this.form.last_name = null;
        this.form.email_address = null;

      },
      setRegistrationData(){
        if(this.connect_method === 1){
          const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 2);
          const rateplan_id = registration_method.rate_plans[0].rateplan_id;
          return {
            registration_method_id: 2,
            rateplan_id: rateplan_id,
            last_name: this.form.last_name,
            room_number: this.form.room_number,
            email_address: this.form.email_address
          }
        } else if(this.connect_method === 2) {
          const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 1);
          const rateplan_id = registration_method.rate_plans[0].rateplan_id;
          return {
            registration_method_id: 1,
            rateplan_id: rateplan_id,
            ...(this.form.first_name && { first_name: this.form.first_name }),
            ...(this.form.last_name && { last_name: this.form.last_name }),
            ...(this.form.email_address && { email_address: this.form.email_address }),
          }
        }
      },
      handleClickConnect: function(){
        this.disabled = true;
        const data = this.setRegistrationData();
        if(this.form.email_address){
          const revinate_data = {
            tokens: [ this.revinate_token ],
            contacts: [
              {
                ...(this.form.first_name && { first_name: this.form.first_name }),
                ...(this.form.last_name && { last_name: this.form.last_name }),
                ...(this.form.email_address && { email: this.form.email_address }),
                 subscribed: this.subscribe
              }
            ]
          };
          Axios.post(this.revinate_url,revinate_data).then(response => {
            this.$emit('emitRegistrationMethodData', data );
          }).catch( error => {
            this.$emit('error', 'Error registering with email address.');
          });
        } else {
          this.$emit('emitRegistrationMethodData', data );
        }
      },
    }
  }
  </script>
  <style>
  @font-face { font-family: 'Jannon'; font-weight: normal; src: url('https://sky-production.s3.amazonaws.com/brandportalimages/maisondelaluz-jannon.woff'); }

  .maisonDeLaLuz .logo svg { width: 300px; }
  .maisonDeLaLuz { overflow-y: scroll; min-height: 100%; background: #FEFAF9; font-size: 20px;  }
  .maisonDeLaLuz body { min-height: 100vh; }
  .maisonDeLaLuz .container { background-color: unset; border-radius: unset; }
  .maisonDeLaLuz .connect-method-form { width: 100%; text-align: left;  }
  .maisonDeLaLuz #app, .maisonDeLaLuz button, .maisonDeLaLuz input[type="text"] { color: #000; }
  .maisonDeLaLuz #app,
  .maisonDeLaLuz button { font-family: 'Jannon'; }
  .maisonDeLaLuz .connect-buttons { display: flex; margin: 0 -5px; }
  .maisonDeLaLuz .connect-buttons > button { margin: 0 5px; font-size: 20px; font-family: "Courier Prime", courier, "Courier New", monospace; }

  .maisonDeLaLuz button { border: unset; cursor: pointer; line-height: 1; background: #484e6b; color: #fff9f8; width: 100%; padding: 20px 0; font-size: 20px; }
  .maisonDeLaLuz button[disabled] { cursor: not-allowed; }
  .maisonDeLaLuz input[type="text"] { padding: 20px 22px; font-size: 20px; border: 1px solid #999; width: 100%;}
  .maisonDeLaLuz .d-block { display: block; }
  .maisonDeLaLuz a { color: #484e6b; text-decoration: underline; font-weight: bold;  }
  .maisonDeLaLuz a:hover { color: #000; }
  .maisonDeLaLuz .terms label a { }
</style>
  